// extracted by mini-css-extract-plugin
module.exports = {"skeletonCard":"SkeletonSociety_skeletonCard__l5lsN","skeletonImage":"SkeletonSociety_skeletonImage__1RNGF","skeletonText":"SkeletonSociety_skeletonText__2TXQM"};